// ===============================================
// File: src/components/Strips/SaveToInspirationButton.jsx
// Drop-in
// Upgrades:
// - a11y: aria-pressed, clearer labels
// - Defensive: ignore if no image
// ===============================================
import React from "react";
import { useInspiration } from "../../contexts/InspirationContext";

export default function SaveToInspirationButton({ image }) {
  const { items, add, remove } = useInspiration();
  const id = image?.id;
  const isSaved = !!id && items.some((i) => i.id === id);

  const onClick = (e) => {
    e.stopPropagation();
    if (!id) return;
    isSaved ? remove(id) : add(image);
  };

  return (
    <button
      onClick={onClick}
      aria-pressed={isSaved}
      className={`px-2 py-1 text-xs rounded-lg shadow ${
        isSaved ? "bg-emerald-600 text-white" : "bg-white/70 backdrop-blur text-gray-800"
      }`}
      title={isSaved ? "Remove from Inspiration" : "Save to Inspiration"}
    >
      {isSaved ? "Saved" : "Save"}
    </button>
  );
}
